import { ErrorDto } from "@/api-connector/play-digital-api/models/shared-models";
import { PlayerDetailModel } from "@/api-connector/play-digital-api/models/account-models";
import { AccountNotificationType } from "../models/authentication-flows";

export function formatSazkaCardNumber(cardId: string) {
    return cardId.slice(0, 1) + " " + cardId.slice(1, 4) + " " + cardId.slice(4, 7) + " " + cardId.slice(7, 10);
}

export function getNotificationState(userProfile: PlayerDetailModel): AccountNotificationType {
    const { email } = userProfile;
    const { birthdate, firstName, lastName, gender } = userProfile.playerPersonalInfo;

    if (!email || !birthdate || !firstName || !lastName || !gender) return "FillInfo";

    if (
        userProfile.pendingContactVerifications?.EMAIL?.status == "PENDING" &&
        userProfile.pendingContactVerifications?.EMAIL?.contactValue == email
    )
        return "VerifyEmail";

    return "None";
}

export function isErrorDto(object: any): object is ErrorDto {
    return "code" in object && "uid" in object;
}

// x mean - get from old code = maybee deprecated
export function parseErrorMessage(ex: unknown, defaultErrorMessage?: string) {
    if (isErrorDto(ex)) {
        switch (ex.code) {
            case "INVALID_CARD_ID": // x
                return "Číslo karty je nesprávné";
            case "INACTIVE_CARD": // x
                return "Karta je neaktivní";

            case "INVALID_EMAIL": // x
                return "Emailová adresa je nesprávná";
            case "INVALID_PHONE": // x
                return "Telefon je nesprávný.<br /> Vyplňte jej ve formátu: XXXXXXXXX (bez mezer a předvolby)";
            case "EMAIL_ALREADY_REGISTERED": // x
                return "Emailová adresa již byla zaregistrována";
            case "PHONE_ALREADY_REGISTERED": // x
            case "MOBILE_PHONE_ALREADY_REGISTERED":
                return "Toto číslo již je registrováno.";
            case "EMPTY_EMAIL": // x
                return "Registrační email nebyl nalezen";
            case "EMPTY_PHONE": // x
                return "Telefon nebyl nalezen";

            case "PASSWORD_EQUAL_TO_USERNAME":
                return "Nelze mít stejné heslo jako tel. číslo.";
            case "NEW_PASSWORD_ALREADY_USED_BETWEEN_OLD_PASSWORDS":
                return "Nové heslo již bylo použito, zadejte jiné heslo.";
            case "PASSWORD_OLD_INVALID":
                return "Chybně zadané stávající heslo.";
            case "PASSWORD_OLD_EQUAL_TO_NEW":
                return "Nové heslo se nemůže shodovat se stávajícím.";

            case "INVALID_TOKEN": // x
                return "Validační token vypršel nebo je nesprávný";
            case "INVALID_PIN":
                return "Zadaný pin vypršel nebo není správný.";
            case "UNAUTHORIZED": // x
                return "Číslo karty nebo heslo je nesprávné";
            case "NO_PENDING_VERIFICATIONS":
                return "Platnost tohoto odkazu vypršela.";
            case "CLIENT_ALREADY_REGISTERED": // x
                return "Klient již byl zaregistrován";

            case "UNDER_AGE": // x
                return "Minimální věk je 18 let";
            case "OVER_AGE": // x
                return "Maximální věk je 130 let";
        }
    }

    return defaultErrorMessage;
}
